import { useQuery } from '@tanstack/react-query'
import { useCurrentProject } from 'src/providers/current-project.provider'
import { ProjectService } from 'src/services/project.service'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { useTranslation } from 'react-i18next'
import { ConfigurationHeaderWrapper } from '../../../_components/configuration-header-wrapper.component'
import ProgrammedMessageList from './_components/programmed-message-list.component'
import { TProgrammedMessage } from './_components/programmed-message.type'

export default function ProgrammedMessagesPage() {
  const { t } = useTranslation()
  const { project } = useCurrentProject()

  const { isLoading, error, data } = useQuery({
    queryKey: ['programmed-messages', project.id],
    queryFn: () => ProjectService.getSelfConfigurationMessages(project.id),
  })

  if (error) {
    return <ErrorQueryHandler error={error} />
  }

  if (isLoading) {
    return <div className="loading" />
  }

  return (
    <ConfigurationHeaderWrapper title={t('pages.configuration.messages.list-programmed-messages')}>
      {data && data.length === 0 ? (
        <p className="c-font-nexa c-text-grey-700">
          {t('pages.configuration.messages.empty-list-instructions')}
        </p>
      ) : (
        <ProgrammedMessageList programmedMessages={data as TProgrammedMessage[]} />
      )}
    </ConfigurationHeaderWrapper>
  )
}
